import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Document({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <Document.Outline {...props} />
  ) : (
    <Document.Solid {...props} />
  );
}

Document.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M7.74634 7.86011C7.74634 7.44589 8.08212 7.11011 8.49634 7.11011H11.2513C11.6656 7.11011 12.0013 7.44589 12.0013 7.86011C12.0013 8.27432 11.6656 8.61011 11.2513 8.61011H8.49634C8.08212 8.61011 7.74634 8.27432 7.74634 7.86011Z"
          fill="currentColor"
        />
        <path
          d="M8.49609 11.2869C8.08188 11.2869 7.74609 11.6227 7.74609 12.0369C7.74609 12.4511 8.08188 12.7869 8.49609 12.7869H15.7161C16.1303 12.7869 16.4661 12.4511 16.4661 12.0369C16.4661 11.6227 16.1303 11.2869 15.7161 11.2869H8.49609Z"
          fill="currentColor"
        />
        <path
          d="M8.49609 15.4734C8.08188 15.4734 7.74609 15.8092 7.74609 16.2234C7.74609 16.6376 8.08188 16.9734 8.49609 16.9734H15.7161C16.1303 16.9734 16.4661 16.6376 16.4661 16.2234C16.4661 15.8092 16.1303 15.4734 15.7161 15.4734H8.49609Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.7446 3.48737C18.8022 2.51471 17.4689 1.99976 15.9085 1.99976L8.21949 2.00374L8.21487 2.00377C6.66655 2.01331 5.34406 2.53189 4.40961 3.50279C3.47794 4.4708 3.00049 5.817 3.00049 7.35676V16.5528C3.00049 18.0998 3.48143 19.4523 4.42076 20.4221C5.36294 21.3948 6.69669 21.9098 8.25713 21.9098L15.9455 21.9068L15.9501 21.9067C17.4985 21.8972 18.8212 21.3783 19.7559 20.4072C20.6877 19.439 21.1655 18.0926 21.1655 16.5528V7.35676C21.1655 5.80958 20.6842 4.45712 19.7446 3.48737ZM8.22411 3.50374L15.9087 3.49976C17.1321 3.49982 18.0523 3.89636 18.6673 4.53114C19.2853 5.16889 19.6655 6.11993 19.6655 7.35676V16.5528C19.6655 17.7829 19.2883 18.73 18.6751 19.367C18.0651 20.0009 17.1534 20.3989 15.9428 20.4068L15.9409 20.4068L8.25628 20.4098C7.03282 20.4097 6.113 20.0132 5.49821 19.3785C4.88054 18.7408 4.50049 17.7897 4.50049 16.5528V7.35676C4.50049 6.12651 4.87753 5.17971 5.49037 4.54297C6.10007 3.90948 7.0114 3.51165 8.22207 3.50375L8.22411 3.50374Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Document.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          d="M15.5164 2H7.48458C4.57125 2 2.875 3.78 2.875 6.83V17.16C2.875 20.26 4.57125 22 7.48458 22H15.5164C18.4767 22 20.125 20.26 20.125 17.16V6.83C20.125 3.78 18.4767 2 15.5164 2Z"
          className="icon-secondary"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.74293 6.65039V6.66039C7.32989 6.66039 6.99543 7.01039 6.99543 7.44039C6.99543 7.87039 7.32989 8.22039 7.74293 8.22039H10.6074C11.0204 8.22039 11.3558 7.87039 11.3558 7.42939C11.3558 7.00039 11.0204 6.65039 10.6074 6.65039H7.74293ZM15.2563 12.7404H7.74293C7.32989 12.7404 6.99543 12.3904 6.99543 11.9604C6.99543 11.5304 7.32989 11.1794 7.74293 11.1794H15.2563C15.6683 11.1794 16.0038 11.5304 16.0038 11.9604C16.0038 12.3904 15.6683 12.7404 15.2563 12.7404ZM15.2563 17.3104H7.74293C7.45543 17.3504 7.17751 17.2004 7.02418 16.9504C6.87085 16.6904 6.87085 16.3604 7.02418 16.1104C7.17751 15.8504 7.45543 15.7104 7.74293 15.7404H15.2563C15.6386 15.7804 15.9271 16.1204 15.9271 16.5304C15.9271 16.9294 15.6386 17.2704 15.2563 17.3104Z"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
